export const universeImage = 'http://www.gsu.by/sites/default/files/images/articles/2020-02/img200214-01.png';

export const defaultImage = 'http://www.gsu.by/sites/default/files/images/articles/2020-02/img200214-01.png';